module.exports = "pegasus_template/assets/blocks/header-5-theme5.png";